import { StateCreator } from 'zustand';
import { AvailabilityStatus } from '../../types/config.types';
import {
  LNG_LOCALSTORAGE_KEY,
  LS_KEY_MENU_COLLAPSE_STATE,
} from '../../const/localstorage.const';
import storage from '../../lib/storage';
import { TLanguages } from '../../types/languages.types';
import { PageBreadcrumb } from '../../types/common.types';

export interface MetaState {
  lng: TLanguages;
  setLng: (lng: TLanguages) => void;
  pageBreadcrumbs: PageBreadcrumb[] | null;
  setPageBreadcrumbs: (breadcrumbs: PageBreadcrumb[] | null) => void;
  remoteConfig: AvailabilityStatus | null;
  setRemoteConfig: (config: AvailabilityStatus) => void;
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
}

const lng = (storage.get(LNG_LOCALSTORAGE_KEY) ?? 'uz') as TLanguages;

const menuCollapsedState = storage.get(LS_KEY_MENU_COLLAPSE_STATE)
  ? (JSON.parse(storage.get(LS_KEY_MENU_COLLAPSE_STATE)!) as boolean)
  : false;

export const createMetaSlice: StateCreator<MetaState, [], [], MetaState> = (
  set,
) => ({
  lng,
  setLng: (lng: TLanguages) => {
    set({
      lng,
    });
  },
  pageBreadcrumbs: null,
  setPageBreadcrumbs: (breadcrumbs: PageBreadcrumb[] | null) => {
    set({ pageBreadcrumbs: breadcrumbs });
  },
  remoteConfig: null,
  setRemoteConfig: (config: AvailabilityStatus) => {
    set({ remoteConfig: config });
  },
  isCollapsed: menuCollapsedState,
  setIsCollapsed: (isCollapsed: boolean) => set({ isCollapsed }),
});
